'use strict';

module.exports = function goldPlanDescription(plan) {
	const planType = (plan && (plan.typeLabel || plan.type)) || 'personal';
	return plan.prefix + plan.price + plan.postfix + ' ' + plan.period + ' ' + planType + ' subscription';
};
